<template>
    <el-container v-wechat-title="title" :style="{ height: this.screenHeight + 'px' }" class="first-page" @keyup.native.enter="submit()" v-if="!caToken">
        <div v-show="isShowDemoPassPNG" style="position: fixed; cursor: pointer; top: 20px; z-index: 1040; right: 30px; width: 150px; height: 150px;background-color: rgb(190, 190, 190, 0.8);">
            <img style="width:100%" src="static/img/DemoPass.png" />
            <span style="width:100%;text-align: center;font-size: 14px;">扫码申请演示账号</span>
        </div>
        <el-main class="login_page">
            <div class="login_div">
                <table style="width: 1024px; border-spacing: 0" cellpadding="0">
                    <tr>
                        <td style="width: 640px">
                            <div class="login_image">
                                <div class="product_slogon">{{ systemRemark }}</div>
                            </div>
                        </td>
                        <td style="padding-left: 40px; padding-right: 20px; position: relative; border-radius: 0 15px 15px 0; background-color: rgba(0, 0, 0, 0.3)">
                            <div class="half-opacity" style="position: absolute; left: 20px; top: 20px">
                                <el-row>
                                    <el-col style="line-height: 30px">
                                        {{ clientName }}
                                    </el-col>
                                </el-row>
                            </div>
                            <div style="font-size: 28px; text-align: left">
                                {{ systemName }}
                            </div>
                            <!-- <div v-if="licenseinfo&&licenseinfo.is_coming_soon" class="align-left fg-danger">{{`License剩余有效期:${licenseinfo&&licenseinfo.expire_days}${licenseinfo&&licenseinfo.expire_unit}`}}</div> -->
                            <el-row>
                                <el-input v-model="user.uid" ref="uid" :clearable="true" :autofocus="true">
                                    <template slot="prepend">
                                        <i class="el-icon-user"></i>
                                    </template>
                                </el-input>
                            </el-row>
                            <el-row>
                                <el-input v-model="user.pwd" ref="pwd" show-password :clearable="true">
                                    <template slot="prepend">
                                        <i class="el-icon-lock"></i>
                                    </template>
                                </el-input>
                            </el-row>
                            <el-row v-if="enableCAPTCHALogin">
                                <el-input v-model="user.verifyCode" ref="verifyCode" :clearable="true" style="width: 59%;" placeholder="请输入验证码"/>
                                <valid-code :identifyCode.sync="identifyCode" style="float: right;z-index: 10000;"></valid-code>
                            </el-row>

                            <el-row>
                                <el-button type="primary" style="width: 100%" @click="submit()" size="medium " icon="el-icon-unlock" v-if="licenseinfo && licenseinfo.is_valid">登 录</el-button>
                                <br />
                                <!-- <div class="align-left fg-main font-size14" style="cursor: pointer; padding-top: 5px" @click="loginAlterPassword()">修改密码？</div> -->
                            </el-row>
                            <div style="position: absolute; right: 20px; bottom: 20px">
                                <img v-if="showLogo" src="../assets/logo/logo_白字.png" style="height: 40px" />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-top: 5px; padding-left: 2px">
                            <div v-if="licenseinfo && licenseinfo.is_coming_soon" class="align-left fg-main font-size14">
                                {{ `License剩余有效期:${licenseinfo && licenseinfo.expire_days}${licenseinfo && licenseinfo.expire_unit}` }}
                            </div>
                            <div v-else-if="licenseinfo && !licenseinfo.is_valid" style="color: red"><strong>Error：</strong>{{ licenseinfo && licenseinfo.error_type }}</div>
                            <div v-if="inaccurateTimeTip && inaccurateTimeTip != ''" class="align-left fg-main font-size15" style="color: red">
                                {{ inaccurateTimeTip }}
                            </div>
                            <br />
                        </td>
                    </tr>
                </table>
            </div>
            <div class="align-right" style="position: fixed; bottom: 0; right: 0; padding: 20px">版本：{{ this.version || '--' }}</div>
        </el-main>
        <LoginAlterPassword :visible.sync="alterPasswordDialogVisible" :username="user.uid"></LoginAlterPassword>
    </el-container>
</template>

<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import LoginAlterPassword from '@/components/LoginAlterPassword.vue'
import ValidCode from '@/components/ValidCode.vue'
import axios from 'axios'
export default {
    name: `Login`,
    components: { LoginAlterPassword, ValidCode },
    data() {
        return {
            title: ``,
            alterPasswordDialogVisible: false,
            screenHeight: document.documentElement.clientHeight,
            user: {
                uid: ``,
                pwd: ``,
                verifyCode: ``,
                exp: 100000
            },
            selectDeptVisible: false,
            licenseinfo: undefined,
            version: undefined,
            passwordMode: this.$root.PasswordMode,
            passwordMaxErrorCount: this.$root.PasswordMaxErrorCount,
            passwordExpiredRemindDays: this.$root.PasswordExpiredRemindDays,
            passwordRegularExpression: this.$root.PasswordRegularExpression,
            passwordRegularTipMsg: this.$root.PasswordRegularTipMsg,
            LoginStateHeartTime: this.$root.LoginStateHeartTime,
            caToken: this.$route.query.ca_token,
            systemName: this.$root.SystemName,
            systemRemark: this.$root.SystemRemark,
            licensetip: null,
            inaccurateTimeTip: null,
            isShowDemoPassPNG: this.$root.IsShowDemoPassPNG == `1`,
            showTipSeconds: this.$root.LocalTimeDiffServerTimeShowTipSeconds || 60,
            enableCAPTCHALogin: this.$root.EnableCAPTCHALogin == `1`,
            identifyCode: ``
        }
    },
    mounted() {
        console.log(this.caToken)
        // 进入登录页时即按系统参数覆盖主题（退出后返回登录页也立即生效）
        this.$store.dispatch(`ADD_SYS_CONFIG`).then(config => {
            Object.assign(this.$root, config)
            this.applyThemeByConfigMode(config.DefaultThemeColorMode)
        }).catch(() => {
            this.applyThemeByConfigMode(this.$root.DefaultThemeColorMode)
        })
        let useCa = this.$root.useCa == `1`
        // 本地环境可打开注释，不然会跳转到ca
        // let useCa = this.$root.useCa == `1` && process.env.NODE_ENV !== `development`
        if (useCa) {
            if (this.caToken) {
                let caUrl = `api/AcisSystem/Authorization/ChangeToken?caToken=${this.caToken}`
                this.myaxios
                    .get(caUrl)
                    .then(this.login)
                    .catch(e => {
                        this.$alert(e, `错误`, {
                            confirmButtonText: `确定`,
                            type: `error`
                        }).then(this.gotoCaLogin)
                    })
            } else {
                this.gotoCaLogin()
            }
        }

        sessionStorage.removeItem(`token`)
        window.onresize = () => {
            this.screenHeight = document.documentElement.clientHeight
        }
        this.loadLicenseInfo()
        this.title = this.systemName

        // 校验是否使用触发器
        this.checkTriggerUsed()
    },
    computed: {
        // ...mapGetters(["departments","hospitals","dept","accessDept"]),
        showLogo() {
            return `${this.$root.HideLogo || `0`}` !== `1`
        },
        clientName() {
            //  return this.hospitals&&this.hospitals.length>0 ?this.hospitals[0].label:"--"
            return this.$root.HospitalName || ``
        },
        isDesktop() {
            return typeof winformMsg != `undefined`
        }
    },
    methods: {
        checkTriggerUsed() {
            this.myaxios.get(`/api/AcisSystem/Authorization/CheckTriggerUsed`)
                .then(data => {
                    if (data && data != ``) {
                        this.$message.info(data)
                    }
                })
        },
        loginAlterPassword() {
            this.alterPasswordDialogVisible = true
        },
        getToken() {
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/GetAuthToken`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` }
            })
            req.then(res => {
                console.log(`11111111111111111111111`, res)
                if (res != null && res.Status === `SUCCESS`) {
                    sessionStorage.setItem(`doctoken`, res.Content)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loginbody(token) {
            let redirect = this.$route.query.redirect
            sessionStorage.setItem(`token`, token)
            sessionStorage.setItem(`caToken`, this.caToken)

            // 获取系统配置并保存Token过期时间
            this.$store.dispatch(`ADD_SYS_CONFIG`).then(config => {
                // 将配置合并到根实例，确保TokenExpirationHours可通过this.$root访问
                Object.assign(this.$root, config)

                // 每次登录强制按系统参数 DefaultThemeColorMode 覆盖本地主题
                this.applyThemeByConfigMode(this.$root.DefaultThemeColorMode)

                // 保存Token过期时间到sessionStorage
                const { saveTokenExpirationTime } = require(`@/utils/tokenExpiration`)
                saveTokenExpirationTime(this.$root)
            }).catch(e => {
                console.error(`获取系统配置失败:`, e)
            })

            this.$store.dispatch(`ADD_CURRENTUSER`)
            this.$store.dispatch(`ADD_OtherSettingColumn`)
            this.$store.dispatch(`ADD_ExtendColumnList`)
            console.log(this.caToken)
            this.getToken()
            // 登陆前验证，不允许重复登录
            this.myaxios
                .get(`api/AcisSystem/Authorization/GetLastLoginTime`)
                .then(onlinedata => {
                    // 最后一次登录的时间data
                    if (onlinedata && this.isDesktop) {
                        console.log(onlinedata)

                        let now = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
                        let check = this.$moment(onlinedata.create_dt).add(this.LoginStateHeartTime, `seconds`).format(`YYYY/MM/DD HH:mm:ss`)
                        console.log(now)
                        console.log(check)
                        if (now < check) {
                            let dttime = this.$moment(check) - this.$moment(now)
                            let dts = dttime / 1000
                            this.$alert(`你已在${onlinedata.work_station}登录${onlinedata.username}，在${dts}秒内不能重复登录，请稍后再试！`, `提醒`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            }).then(data => {
                                if (this.caToken) {
                                    this.gotoCaLogin()
                                }
                            })
                            return
                        }
                    }
                    // 在这里记录登录日志
                    // let clientPath = ``
                    // if (window.ClientPath) {
                    //     clientPath = window.ClientPath.clientPath
                    // }
                    // this.myaxios
                    //     .getNoloading(`api/AcisSystem/Authorization/UploadLoginTime?clientPath=${clientPath}`)
                    //     .then(data => {
                    //         console.log(`登录成功`)
                    //     })
                    // 获取多语言
                    this.$store.dispatch(`ADD_LANGUAGES`).then(data => {
                    })
                    let r = typeof winformMsg
                    if (r != `undefined`) {
                        var cefJson = {
                            action: `login`,
                            token: token,
                            caToken: this.caToken
                        }
                        winformMsg.acceptMessage(cefJson)
                    }
                    let user = Object.assign({}, this.user)
                    if (user.uid != ``) {
                        this.myaxios
                            .post(`api/AcisSystem/Authorization/GetUpdatePwdTip`, {
                                user_agent: `chrome`,
                                timestamp: new Date().getTime(),
                                data: user
                            })
                            .then(data => {
                                if (data) {
                                    this.$alert(data, `提醒`, {
                                        dangerouslyUseHTMLString: true,
                                        type: `warning`
                                    }).then(data => {
                                        // 服务端验证返回有登陆提示 且开启了 强效验模式，必须修改密码
                                        if (this.passwordMode == `1`) {
                                            this.alterPasswordDialogVisible = true
                                        } else {
                                            if (redirect && redirect != `/`) {
                                                this.$router.push({ path: redirect }).catch(err => err)
                                            } else {
                                                this.$router.push({ path: `/` }).catch(err => err)
                                            }
                                        }
                                    })
                                } else {
                                    if (redirect && redirect != `/`) {
                                        this.$router.push({ path: redirect }).catch(err => err)
                                    } else {
                                        this.$router.push({ path: `/` }).catch(err => err)
                                    }
                                }
                            })
                            .catch()
                    } else {
                        if (redirect && redirect != `/`) {
                            this.$router.push({ path: redirect }).catch(err => err)
                        } else {
                            this.$router.push({ path: `/` }).catch(err => err)
                        }
                    }
                })
        },
        login(token) {
            // 如果直接打开ca登录页面，并且登录成功后进入到登录页面
            if (this.caToken && this.$root.useCa == `1`) {
                this.$store.dispatch(`Get_Menu`).then((menus) => {
                    console.log(menus)
                    if (menus.findIndex(item => item.code === `6298723fae9d12ba9730c36787e868e8`) == -1) {
                        this.$alert(`CA未授权，无法使用CA功能`, `提醒`, {
                            dangerouslyUseHTMLString: true,
                            type: `warning`
                        })
                    } else {
                        this.loginbody(token)
                    }
                })
            } else {
                this.loginbody(token)
            }
        },
        submit() {
            if (_.trim(this.user.uid) == ``) {
                this.$message.error(`请输入用户名`)
                this.$refs.uid.focus()
                return
            }
            if (_.trim(this.user.pwd) == ``) {
                this.$message.error(`请输入密码`)
                this.$refs.pwd.focus()
                return
            }

            if (this.enableCAPTCHALogin) {
                if (!this.user.verifyCode || _.trim(this.user.verifyCode) == ``) {
                    this.$message.error(`请输入验证码`)
                    this.$refs.verifyCode.focus()
                    return
                } else if (this.user.verifyCode && this.user.verifyCode.toLowerCase() !== this.identifyCode.toLowerCase()) {
                    this.$message.error(`验证码输入错误`)
                    this.$refs.verifyCode.focus()
                    return
                }
            }

            let user = Object.assign({}, this.user)
            if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                let encryptor = new JSEncrypt()
                encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                user.pwd = encryptor.encrypt(user.pwd)
            }

            this.myaxios
                .post(`api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: user
                })
                .then(this.login)
        },
        loadLicenseInfo() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/LicenseStatus`)
            let req2 = this.myaxios.get(`/api/AcisSystem/SystemServer/Version`)
            this.myaxios
                .all(req, req2)
                .then(([data, version]) => {
                    this.licenseinfo = data
                    this.version = version
                    if (this.licenseinfo && this.licenseinfo.is_coming_soon) {
                        this.licensetip = `License剩余有效期:${this.licenseinfo && this.licenseinfo.expire_days}${this.licenseinfo && this.licenseinfo.expire_unit}`
                        this.$alert(this.licensetip, `提醒`, {
                            dangerouslyUseHTMLString: true,
                            type: `warning`
                        })
                    }
                    this.valiTimeAddTip()
                })
                .catch(e => {
                    console.log(e)
                })
        },
        valiTimeAddTip() {
            let localNow = new Date()
            let serverTime = this.$moment(this.licenseinfo.server_time)
            let diffSeconds = Math.abs(this.$moment(localNow).diff(serverTime, `seconds`))

            // config 设置的 LocalTimeDiffServerTimeShowTipSeconds 值
            let tipSeconds = parseInt(this.showTipSeconds)
            if (!tipSeconds || tipSeconds <= 0) {
                tipSeconds = 60
            }
            // 相差如果大于 LocalTimeDiffServerTimeShowTipSeconds 设置的值 就显示 提示文本
            if (diffSeconds > tipSeconds) {
                console.log(`本地获取的时间:` + this.$moment(localNow).format(`YYYY-MM-DD HH:mm:ss`))
                this.inaccurateTimeTip = `当前设备时间与服务器时间（${serverTime.format(`YYYY-MM-DD hh:mm:ss`)}）相差${diffSeconds}秒，请调整当前设备时间！`
            }
        },
        gotoCaLogin() {
            this.$store.dispatch(`Get_Menu`).then((menus) => {
                console.log(menus)
                if (menus.findIndex(item => item.code === `6298723fae9d12ba9730c36787e868e8`) == -1) {
                    this.$alert(`CA未授权，无法使用CA功能`, `提醒`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    })
                } else {
                    let redirect = this.$route.query.redirect
                    if (!redirect || redirect == `undefined`) redirect = ``
                    window.location.href = `${this.$root.CaLoginUrl}?app_key=${this.$root.appKey}&redirect=${redirect}`
                }
            })
        },
        applyThemeByConfigMode(mode) {
            const modeVal = `${mode || `1`}`
            let theme = `theme-dark`
            if (modeVal === `2`) {
                theme = `theme-light`
            } else if (modeVal === `3`) {
                theme = `theme-his-blue`
            }

            localStorage.setItem(`app_theme`, theme)

            let bodyClass = theme
            if (theme === `theme-his-blue`) {
                bodyClass = `theme-dark theme-his-blue`
            }
            const appRoot = document.getElementById(`app`)
            if (appRoot && appRoot.parentElement) {
                appRoot.parentElement.className = bodyClass
            }
        }
    }
}
</script>

<style scoped>
.first-page .el-header {
    background: black;
    color: whitesmoke;
    height: 30px !important;
}

.login_page {
    color: white;
    width: 100%;
    height: 100%;
    background-image: url('../assets/bg.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.login_page .half-opacity {
    color: rgba(255, 255, 255, 0.5);
}

.login_div {
    left: 50%;
    margin-left: -512px;
    top: 50%;
    margin-top: -260px;
    display: inline-block;
    position: fixed;
    background-repeat: no-repeat;
}

.login_div .el-row {
    padding-top: 20px;
}
.login_image {
    width: 640px;
    height: 480px;
    position: relative;
    border-radius: 15px 0 0 15px;
    background-image: url('../assets/anesthesia.jpg');
    background-repeat: no-repeat;
    background-position-x: -85px;
}

.product_slogon {
    padding: 20px;
    position: absolute;
    bottom: 20px;
    left: 20px;
    display: inline-block;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue